// HAPPYCAP_FOOTER_LIGHT_V1
// HAPPYCAP_LANDING_MOBILE_MATCH_V1
// HAPPYCAP_LANDING_REFINEMENT_V1
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaArrowUp } from "react-icons/fa";
import CookieConsent from "../components/CookieConsent";

export default function LandingPage() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [consentGiven, setConsentGiven] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("access");
    if (token) {
      navigate("/feed");
    }
  }, [navigate]);

  useEffect(() => {
    const browserLang = navigator.language.split("-")[0];
    if (!localStorage.getItem("i18nextLng")) {
      i18n.changeLanguage(browserLang);
    }
  }, [i18n]);

  const sections = [
    {
      id: "about",
      title: t("about.title"),
      text: t("about.text"),
      image: "/img/about-photo.jpg",
      alt: t("about.alt"),
    },
    {
      id: "goal",
      title: t("goal.title"),
      text: t("goal.text"),
      image: "/img/goal-photo.jpg",
      alt: t("goal.alt"),
    },
    {
      id: "philosophy",
      title: t("philosophy.title"),
      text: t("philosophy.text"),
      image: "/img/philosophy-photo.jpg",
      alt: t("philosophy.alt"),
    },
    /* HAPPYCAP_LANDING_HIDE_MONETIZATION_V1
    {
      id: "monetization",
      title: t("monetization.title"),
      text: t("monetization.text"),
      image: "/img/monetization.png",
      alt: t("monetization.alt"),
    },
    */
    {
      id: "how",
      title: t("how.title"),
      text: t("how.text"),
      image: "/img/how-photo.jpg",
      alt: t("how.alt"),
    },
    {
      id: "protection",
      title: t("protection.title"),
      text: t("protection.text"),
      image: "/img/protection-photo.jpg",
      alt: t("protection.alt"),
    },
  ];

  function ScrollToTopButton() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
      const toggleVisibility = () => {
        setIsVisible(window.scrollY > 300);
      };
      window.addEventListener("scroll", toggleVisibility);
      return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "auto" });
    };

    return (
      isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-6 right-10 z-50 bg-orange-500 hover:bg-orange-600 text-white w-14 h-14 text-2xl font-bold shadow-lg hover:shadow-xl rounded-full transition-all duration-300 flex items-center justify-center"
          aria-label={t("a11y.scroll_top")}
        >
          <FaArrowUp />
        </button>
      )
    );
  }

  return (
    <>
      <CookieConsent onConsentGiven={() => setConsentGiven(true)} />

      <div className="font-sans bg-[#DCECF9]" style={{ fontFamily: "'Poppins', sans-serif" }}>
        <main role="main" aria-label={t("a11y.main_content")}>
          {/* HAPPYCAP_HERO_EDITORIAL_V1 */}
          <header className="mx-auto max-w-5xl px-5 pb-7 pt-5 text-center sm:px-8 sm:pb-9 sm:pt-9">

            {/* Identidad de marca */}
            <div className="mb-6 sm:mb-8">
              <p
                className="font-extrabold leading-none tracking-[-0.045em] text-[#245580]"
                style={{ fontSize: "clamp(2.1rem, 5.5vw, 3.7rem)" }}
              >
                HAPPYCAP<span className="font-semibold text-[#247BA8]">.eu</span>
              </p>
            </div>

            {/* Mensaje principal */}
            <h1
              className="mx-auto max-w-4xl font-bold leading-[1.12] tracking-[-0.045em] text-[#245580]"
              style={{ fontSize: "clamp(2.45rem, 6vw, 4.9rem)" }}
            >
              Handicapé,{" "}
              <span className="text-[#E78B32]">et alors&nbsp;?</span>
            </h1>

            {/* Descripción */}
            <p className="mx-auto mt-6 max-w-2xl text-base font-normal leading-relaxed text-[#45667D] sm:mt-7 sm:text-lg md:text-xl">
              Le réseau social dédié aux personnes concernées par le handicap et les maladies rares.
            </p>

            {/* Acceso a la comunidad */}
            <button
              type="button"
              onClick={() => navigate("/login")}
              disabled={!consentGiven}
              className={`mt-8 inline-flex min-h-12 items-center justify-center gap-3 rounded-xl border-2 px-8 py-3 font-semibold transition-all duration-200 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-orange-200 sm:mt-9 ${
                consentGiven
                  ? "border-orange-400 bg-transparent text-orange-500 shadow-sm hover:bg-orange-400/10 hover:shadow-md"
                  : "cursor-not-allowed border-gray-300 bg-transparent text-gray-400"
              }`}
              aria-label={t("landing.enter")}
            >
              <span>{t("landing.enter")}</span>
              <span aria-hidden="true" className="text-lg leading-none">→</span>
            </button>

          </header>

          {/* HAPPYCAP_LANDING_EDITORIAL_SCROLL_V1 */}
          <div className="bg-[#DCECF9] px-4 pb-10 sm:px-6 sm:pb-14">
            <div className="mx-auto max-w-6xl space-y-5 sm:space-y-7">
              {sections.map((section, index) => (
                <section
                  key={section.id}
                  id={section.id}
                  aria-labelledby={`${section.id}-title`}
                  className="group overflow-hidden rounded-[26px] border border-white/80 bg-white shadow-[0_10px_35px_rgba(22,63,99,0.065)] sm:rounded-[30px]"
                >
                  <div
                    className={`grid items-center gap-0 md:grid-cols-2 ${
                      index % 2 === 1 ? "md:[&>div:first-child]:order-2" : ""
                    }`}
                  >
                    <div className="relative overflow-hidden bg-[#EAF3FB]">
                      <img
                        src={section.image}
                        alt={section.alt}
                        className="h-56 w-full object-cover sm:h-72 md:h-[330px] lg:h-[365px]"
                        loading="lazy"
                      />
                    </div>

                    <div className="flex flex-col justify-center px-6 py-7 sm:px-9 sm:py-10 lg:px-12">
                      <div
                        aria-hidden="true"
                        className="mb-5 h-1 w-11 rounded-full bg-[#E78B32]"
                      />

                      <h2
                        id={`${section.id}-title`}
                        className="mb-4 text-[clamp(1.55rem,3vw,2.15rem)] font-bold leading-tight tracking-tight text-[#163F63]"
                      >
                        {section.title}
                      </h2>

                      <p className="max-w-prose whitespace-pre-line text-base leading-[1.8] text-[#45647C] sm:text-[1.05rem]">
                        {section.text}
                      </p>
                    </div>
                  </div>
                </section>
              ))}
            </div>
          </div>

          <section className="py-12 bg-[#EAF3FB] text-center">
            <p className="text-lg font-semibold text-gray-700 mb-4">
              {t("landing.orphanet_support")}
            </p>
            <a href="https://www.orpha.net/" target="_blank" rel="noopener noreferrer">
              <img
                src="/img/logo-orphanet.png"
                alt="Orphanet"
                className="mx-auto h-16 hover:opacity-80 transition"
              />
            </a>
          </section>
        </main>

        <footer className="happycap-footer-light bg-[#EAF3FB] text-[#45647C] border-t border-[#C9DBEA] py-5 text-sm">
          <div className="max-w-7xl mx-auto px-4 text-center space-y-2">
            <div className="flex flex-wrap justify-center gap-4">
              <Link to="/politica/terms" className="hover:underline">
                {t("footer.terms")}
              </Link>
              <Link to="/politica/privacy" className="hover:underline">
                {t("footer.privacy")}
              </Link>
              <Link to="/politica/cookies" className="hover:underline">
                {t("footer.cookies")}
              </Link>
              <Link to="/politica/legal" className="hover:underline">
                {t("footer.legal")}
              </Link>
            </div>
            <p className="text-xs">© {new Date().getFullYear()} Happycap.eu</p>
          </div>
        </footer>

        <ScrollToTopButton />
      </div>
    </>
  );
}
